angular.module('env.data.rest.model', [

    'env.data.rest.model.fieldDefinition',
    'env.data.rest.model.modelDefinition',
    'env.data.rest.model.representationModel',
    'env.data.rest.model.modelFactory',
    'env.data.rest.model.validationTemplates'
]);